import { css, Global, useTheme } from '@emotion/react';

export function BaseStyles() {
  const theme = useTheme();

  const fontFamilyDefault = [theme.typography.fontFamily, FallbackFontFamily.DEFAULT]
    .filter(Boolean)
    .join(', ');

  const fontFamilyMono = [FallbackFontFamily.MONO].filter(Boolean).join(', ');

  return (
    <Global
      styles={css`
        html {
          box-sizing: border-box;
        }

        html,
        body,
        div,
        span,
        applet,
        object,
        iframe,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        p,
        blockquote,
        pre,
        a,
        abbr,
        acronym,
        address,
        big,
        cite,
        code,
        del,
        dfn,
        em,
        img,
        ins,
        kbd,
        q,
        s,
        samp,
        small,
        strike,
        strong,
        sub,
        sup,
        tt,
        var,
        b,
        u,
        i,
        center,
        dl,
        dt,
        dd,
        ol,
        ul,
        li,
        fieldset,
        form,
        label,
        legend,
        table,
        caption,
        tbody,
        tfoot,
        thead,
        tr,
        th,
        td,
        article,
        aside,
        canvas,
        details,
        embed,
        figure,
        figcaption,
        footer,
        header,
        hgroup,
        menu,
        nav,
        output,
        ruby,
        section,
        summary,
        time,
        mark,
        audio,
        video {
          margin: 0;
          padding: 0;
          border: 0;
          font-size: 100%;
          font: inherit;
          vertical-align: baseline;
        }
        body {
          color: ${theme.color['text/default']};
          font-family: ${fontFamilyDefault};
          font-size: 14px;
          font-weight: 400;
          line-height: 1.5;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: 0;
          background-color: ${theme.color['background/default']};
        }
        *,
        *::before,
        *::after {
          box-sizing: inherit;
        }
        /* HTML5 display-role reset for older browsers */
        article,
        aside,
        details,
        figcaption,
        figure,
        footer,
        header,
        hgroup,
        menu,
        nav,
        section {
          display: block;
        }
        body {
          line-height: 1;
        }
        ol,
        ul {
          list-style: none;
        }
        blockquote,
        q {
          quotes: none;
        }
        blockquote:before,
        blockquote:after,
        q:before,
        q:after {
          content: '';
          content: none;
        }
        table {
          border-collapse: collapse;
          border-spacing: 0;
        }
        code,
        pre,
        kbd,
        var,
        samp {
          font-family: ${fontFamilyMono};
        }

        .kc-console-icon {
          width: 1em;
          min-width: 1em;
          height: 1em;
          vertical-align: -0.125em;
        }
      `}
    />
  );
}

const FallbackFontFamily = {
  DEFAULT:
    '"Pretendard Variable", Pretendard, Roboto, "Noto Sans KR", "Malgun Gothic", "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", -apple-system, BlinkMacSystemFont, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  MONO: 'SFMono-Regular, "SF Mono", "Roboto Mono", "Segoe UI Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace',
} as const;
